import { colors } from '@components/theme';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Hidden,
  IconButton,
  Menu as MenuDropdown,
  MenuItem,
  Toolbar,
  Typography
} from '@material-ui/core';
import { Close, ExitToAppOutlined, Menu } from '@material-ui/icons';
import React, { ReactElement } from 'react';
import { useBannerContext, useMobileOpen } from './MainLayoutContext';

export const MainNavMenu = ({
  logoSrc,
  children,
  userName,
  isAuthenticated,
  signOut,
  noShowLogo
}: {
  logoSrc: string;
  isAuthenticated: boolean;
  signOut: () => void;
  userName: string;
  children?: React.ReactNode;
  noShowLogo?: boolean;
}): ReactElement => {
  const [, setMobileOpen] = useMobileOpen();
  const { showBanner, bannerContent, setBannerState } = useBannerContext();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    setAnchorEl(null);
    signOut();
  };

  return (
    <React.Fragment>
      <AppBar color='transparent'>
        <Toolbar style={{ height: '5rem' }}>
          <Hidden smUp>
            <IconButton className='mr-4' onClick={() => setMobileOpen(true)}>
              <Menu />
            </IconButton>
          </Hidden>
          <Box height={36}>{!noShowLogo && <img alt='' src={logoSrc} style={{ height: '100%' }} />}</Box>
          {children ? children : null}
          <Box display='flex' alignItems='center'>
            <Avatar
              style={{ backgroundColor: colors.secondary.main, cursor: 'pointer' }}
              src={''}
              onClick={handleClick}
            />
            <Box ml={1}>
              <Typography variant='subtitle1'>{isAuthenticated && userName}</Typography>
            </Box>
          </Box>
          <MenuDropdown
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            getContentAnchorEl={null}
          >
            <MenuItem onClick={handleLogout}>
              <Box mr={1}>
                <ExitToAppOutlined />
              </Box>
              Sign Out
            </MenuItem>
          </MenuDropdown>
        </Toolbar>
      </AppBar>
      {showBanner && (
        <Box
          display='flex'
          position='absolute'
          left={0}
          right={0}
          top='5rem'
          py={1}
          px={2}
          style={{
            background: colors.secondary.dark,
            color: colors.white,
            zIndex: 11
          }}
        >
          <Box width='100%' display='flex' alignItems='center' justifyContent='center'>
            {bannerContent}
          </Box>
          <Button size='small' onClick={() => setBannerState(false)}>
            <Close style={{ color: colors.white }} />
          </Button>
        </Box>
      )}
    </React.Fragment>
  );
};
